/***
 * @author zhanglixin
 * @description  fetch method encapsulation
 */

function getAccessToken() {
    let _search = location.search;
    location._query = {};
    location._query['lang'] = 'en';
    let queryArray = [];
    if (_search) {
        _search = _search.replace('?', '');
        queryArray = _search.split('&');
        for (let i = 0; i < queryArray.length; i++) {
            location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
        }
    }
    let accessToken = location._query['accessToken'] || location._query['access_token'];
    let domain = location._query['domain'] || 'https://coursedev.e-ai-edu.com';
    return {
        accessToken,
        domain
    }
}
const { accessToken, domain } = getAccessToken();

//将对象转成字url连接符串如{a:1,b:2}=>a=1&b=2
export const objectToStringify = (obj) => {
    let result = '';
    for (let item in obj) {
        result += '&' + item + '=' + encodeURIComponent(obj[item])
    }
    if (result) {
        result = result.slice(1)//去掉第一个&
    }
    return result
}

/**
* 错误处理
* @param error
*/
const handleError = error => {
    error && alert(error);
    return {   //防止页面崩溃，因为每个接口都有判断res.code以及data
        code: -1,
        data: false,
    };
};


class http {
    /**
     *静态的fetch请求通用方法
     * @param url
     * @param options
     * @returns {Promise<unknown>}
     */
    static handleFetch(url = '', options = {}) {
        const defaultOptions = {
            credentials: 'include', /*允许携带cookies*/
            mode: 'cors',/*允许跨域**/
            headers: {
                'X-Access-Token': accessToken,
            },
        };
        if (options.method === 'POST' || 'PUT') {
            defaultOptions.headers['Content-Type'] = 'application/json; charset=utf-8';
        }
        const newOptions = { ...defaultOptions, ...options };
        return fetch(url, newOptions)
            .then(res => res.json())
            .then(res => {
                if (res.error) {
                    throw new Error(res.error.message);
                } else {
                    return res;
                }
            })
            .catch(handleError);
    }

    /**
     *post请求方式
     * @param url
     * @returns {Promise<unknown>}
     */
    post(url, params = {}, option = {}) {
        const options = Object.assign({ method: 'POST' }, option);
        options.body = JSON.stringify(params);
        //上传时 使用FormData
        if (options.type === 'FormData' && options.body !== 'undefined') {
            let params = new FormData();
            for (let key of Object.keys(options.body)) {
                params.append(key, options.body[key]);
            }
            options.body = params;
        }
        return http.handleFetch(url, options);
    }

    /**
     * put方法
     * @param url
     * @returns {Promise<unknown>}
     */
    put(url, params = {}, option = {}) {
        const options = Object.assign({ method: 'PUT' }, option);
        options.body = JSON.stringify(params);
        return http.handleFetch(url, options);
    }

    /**
     * get请求方式
     * @param url
     * @param option
     */
    get(url, option = {}) {
        const options = Object.assign({ method: 'GET' }, option);
        return http.handleFetch(url, options);
    }
}

const requestFn = new http();
export const { post, get, put } = requestFn;
export default requestFn;
export { domain as baseUrl, accessToken }